export default {
  briumSuperAdmin: "brium.admin",
  briumUniversityAdmin: "brium.university-admin",
  briumFacultyAdmin: "brium.faculty-admin",
  briumResearcher: "brium.researcher",
};
